module.exports = __webpack_public_path__ + "static/media/CBNImg2.478f2271.webp";